import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CABIN_CLASS, CABIN_CLASS_MAP } from "src/constants";
import { searchDataActions } from "src/store/search";
import { CabinClassItem } from "./CabinClassItem";
import classes from "./CabinClassItemGroup.module.css";

import { useDeviceContext } from "src/context/device-context";
import { useLocaleContext } from "src/context/locale-context";

export function CabinClassItemGroup({ defaultEnabled = true }) {
  const dispatch = useDispatch();
  const { isMobile } = useDeviceContext();
  const { getStringRes } = useLocaleContext();
  const cabinClassValue = useSelector((state) => state.search.userInput.cabinClass);

  const onItemSelectedHandler = (value) => {
    console.log("rerender on onItemSelectedHandler CabinClassItemGroup DISPATCH");
    if (isMobile) {
      dispatch(searchDataActions.updateUserInputCabinClass(value));
    } else {
      dispatch(searchDataActions.updateCabinClass(value));
      dispatch(searchDataActions.fillUserInputPassengerOptions());
    }
  };

  useEffect(() => {
    if (!cabinClassValue && defaultEnabled) {
      dispatch(searchDataActions.updateCabinClass(CABIN_CLASS.economy));
    }
  });

  return (
    <ul className={classes.container}>
      {Object.values(CABIN_CLASS).map((key) => (
        <CabinClassItem
          key={key}
          id={key}
          label={getStringRes(CABIN_CLASS_MAP[key])}
          checked={key === cabinClassValue}
          onSelect={onItemSelectedHandler}
        />
      ))}
    </ul>
  );
}
